import { useMutation } from '@tanstack/react-query';
import { trpc } from '@/utils/trpc';

export const useRequestDataDeletion = () => {
  return useMutation(
    trpc.organizationsRouter.createDataDeletionRequest.mutationOptions(),
  );
};
